import type { AdminAgentAction } from "../modules/types";
import { adminApiGet } from "./utils";

export const adminAgentActionsApi = {
  getAll: (workspaceId?: string): Promise<AdminAgentAction[]> =>
    adminApiGet<AdminAgentAction[]>(
      workspaceId
        ? `/agent_actions?workspace_id=${encodeURIComponent(workspaceId)}`
        : "/agent_actions",
    ),

  getById: (id: string): Promise<AdminAgentAction> =>
    adminApiGet<AdminAgentAction>(`/agent_actions/${id}`),
};
